// @flow

import { PaymentTermConfiguration } from './payment-term-configuration'

export default class OrderItemPaymentConfiguration {
  paymentTermConfigurations: PaymentTermConfiguration[]
}

const buildOrderItemPaymentConfiguration = function (paymentTermConfigurations: PaymentTermConfiguration[]): OrderItemPaymentConfiguration {
  const paymentConfiguration = new OrderItemPaymentConfiguration()
  paymentConfiguration.paymentTermConfigurations = paymentTermConfigurations
  return paymentConfiguration
}

export {
  buildOrderItemPaymentConfiguration
}



// WEBPACK FOOTER //
// ./src/types/order-item-payment-configuration.js